import { render, staticRenderFns } from "./SparepartsTable.vue?vue&type=template&id=3fe01f7a&"
import script from "./SparepartsTable.vue?vue&type=script&lang=js&"
export * from "./SparepartsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports